module.exports = __webpack_public_path__ + "img/alter-ego_3-4_poster.d42c0c7.jpg";